import { useCallback } from 'react';

import { usePublish } from '@atlaskit/rovo-triggers';

import { fg } from '@confluence/feature-gating';

export const usePublishDatabaseReferencingContent = () => {
	const publish = usePublish('ai-mate');

	const publishDatabaseReferencingContent = useCallback(
		(selectedElementIds: string[] | undefined) => {
			if (fg('confluence_frontend_rovo_db_referencing_content')) {
				publish({
					type: 'database-context-payload',
					source: 'CONFLUENCE_DATABASE',
					openChat: false,
					data: {
						selectedElementIds,
					},
				});
			}
		},
		[publish],
	);

	return { publishDatabaseReferencingContent };
};
